import { c as _c } from "react/compiler-runtime";
import { addBookmark, deleteBookmark } from '@module/apis/client-side/bookmark';
import type { AddBookmarkParams, AddBookmarkResponse, DeleteBookmarkParams, DeleteBookmarkResponse } from '@module/apis/client-side/bookmark/type';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { bookmarkQueryKeys } from './bookmarkQueryKeys';
export const useAddBookmarkMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = bookmarkQueryKeys.addBookmark();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useDeleteBookmarkMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = bookmarkQueryKeys.deleteBookmark();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp2,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
function _temp(addBookmarkParams) {
  return addBookmark(addBookmarkParams);
}
function _temp2(deleteBookmarkParams) {
  return deleteBookmark(deleteBookmarkParams);
}